import { computeRateLegend } from 'utils/rateLegend';

import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID, TEST_ID_BIN } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

// Rate-legend swatches. Layer 3 owns the actual color via the swatch{Low,
// Medium,High} modifier classes — we only pick the modifier by bin index.
// The single-rate (`isZoneMask`) case renders one `zoneMaskChip` instead of
// the three-bin row.
const RateLegend: FunctionComponent<Props> = ({
    bounds,
    className = '',
    testId = TEST_ID,
    title,
    zoneMaskLabel
}) => {
    const bins = computeRateLegend({ bounds });
    const isUniform = bins.length === 1 && bins[0].isZoneMask;
    const swatchModifiers = [styles.swatchLow, styles.swatchMedium, styles.swatchHigh];

    return (
        <VerticalContainer className={`${className} ${styles.rateLegend}`} testId={testId}>
            <Wrapper className={styles.title}>{title}</Wrapper>

            {isUniform ? (
                <HorizontalContainer className={styles.zoneMaskChip}>
                    <Wrapper className={styles.zoneMaskLabel}>
                        {`${zoneMaskLabel}: ${bins[0].label}`}
                    </Wrapper>
                </HorizontalContainer>
            ) : (
                <HorizontalContainer className={styles.swatches}>
                    {bins.map((bin, index) => (
                        <VerticalContainer
                            className={`${styles.swatch} ${swatchModifiers[index] ?? ''}`}
                            key={`${bin.label}-${index}`}
                            testId={`${TEST_ID_BIN}-${index}`}>
                            <Wrapper className={styles.swatchLabel}>{bin.label}</Wrapper>
                        </VerticalContainer>
                    ))}
                </HorizontalContainer>
            )}
        </VerticalContainer>
    );
};

export default RateLegend;
